import PropTypes from "prop-types";
import React from "react";
import moment from "moment";
import {FaSolidIcon} from "../FontAwesomeIcons";
import {formatCurrency} from "../../helpers/CurrencyHelpers";

export default class ImpagatoCard extends React.Component {

    constructor(props) {
        super(props);
        this.state = {
            advancesOpen: !!props.defaultAdvancesOpen
        }
        this.badgeStyle = {
            fontSize: "11px"
        }
        this.toggleButtonStyle = {
            cursor: "pointer"
        }
    }

    getPayment = _ => this.props.impagato || {}

    hasPaymentInfo = _ => {
        const payment = this.getPayment()
        return !!payment.id_pagamento || (payment.acconti && payment.acconti.length > 0)
    }

    getAdvances = _ => {
        const payment = this.getPayment()
        return payment.acconti || []
    }

    getTotalAmount = _ => parseFloat(this.getPayment().importo || 0)

    getPaidAmount = _ => {
        const payment = this.getPayment()
        const paidAmount = this.getAdvances().reduce((total, advance) => {
            const currentAdvancePayments = advance.pagamenti || []
            if (currentAdvancePayments.length > 0) {
                return total + currentAdvancePayments.reduce((advanceTotal, currentPayment) =>
                    advanceTotal + parseFloat(currentPayment.importo || 0), 0)
            }
            return total + parseFloat(advance.importo || 0)
        }, 0)

        if (paidAmount > 0) return paidAmount
        if (parseInt(payment.pagato) === 1) return this.getTotalAmount()
        return 0
    }

    getRemainingAmount = _ => {
        const remainingAmount = this.getTotalAmount() - this.getPaidAmount()
        return remainingAmount > 0 ? remainingAmount : 0
    }

    getStatusLabel = _ => {
        if (this.getRemainingAmount() > 0) return "Acconto versato"
        return "Pagamento completato"
    }

    formatPaymentMethod = method => {
        if (!method) return "Metodo non specificato"
        return method
            .replaceAll("_", " ")
            .replaceAll("-", " ")
            .replace(/\b\w/g, char => char.toUpperCase())
    }

    toggleAdvances = _ => {
        this.setState({advancesOpen: !this.state.advancesOpen})
    }

    renderAdvancePayments = advance => {
        const payments = advance.pagamenti || []
        if (!payments.length) {
            return <small className={"text-muted"}>Nessun metodo di pagamento registrato</small>
        }

        return payments.map(payment =>
            <div key={payment.id_pagamento} className={"small text-muted mt-1"}>
                {this.formatPaymentMethod(payment.metodo_pagamento)}
                {" · "}
                {formatCurrency(payment.importo || 0, "EUR", "it-IT")}
            </div>
        )
    }

    render() {
        if (!this.hasPaymentInfo()) return ""

        const advances = this.getAdvances()
        const paidAmount = this.getPaidAmount()
        const totalAmount = this.getTotalAmount()
        const remainingAmount = this.getRemainingAmount()

        return (
            <div className={"card border-0 shadow-sm text-left mt-3"}>
                <div className={"card-body"}>
                    <div className={"d-flex justify-content-between align-items-center"}>
                        <div className={"d-flex align-items-center font-weight-bold"}>
                            Pagamento
                            <span
                                className={"ml-2 badge " + (remainingAmount > 0 ? "badge-warning" : "badge-success")}
                                style={this.badgeStyle}
                            >
                                {this.getStatusLabel()}
                            </span>
                        </div>
                    </div>

                    <div className={"row text-center mt-3"}>
                        <div className={"col-4"}>
                            <small className={"text-muted d-block"}>Totale</small>
                            <div className={"font-weight-bold"}>{formatCurrency(totalAmount, "EUR", "it-IT")}</div>
                        </div>
                        <div className={"col-4"}>
                            <small className={"text-muted d-block"}>Gi&agrave; pagato</small>
                            <div className={"font-weight-bold text-success"}>
                                {formatCurrency(paidAmount, "EUR", "it-IT")}
                            </div>
                        </div>
                        <div className={"col-4"}>
                            <small className={"text-muted d-block"}>Residuo</small>
                            <div className={"font-weight-bold " + (remainingAmount > 0 ? "text-warning" : "text-success")}>
                                {formatCurrency(remainingAmount, "EUR", "it-IT")}
                            </div>
                        </div>
                    </div>

                    {
                        advances.length > 0 &&
                        <div className={"mt-3"}>
                            <div
                                className={"d-flex justify-content-between align-items-center text-muted"}
                                style={this.toggleButtonStyle}
                                onClick={this.toggleAdvances}
                            >
                                <small>
                                    Acconti registrati: <b>{advances.length}</b>
                                </small>
                                <small>
                                    {this.state.advancesOpen ? "Nascondi acconti" : "Mostra acconti"}
                                    <span className={"ml-2"}>
                                        <FaSolidIcon name={this.state.advancesOpen ? "chevron-up" : "chevron-down"}/>
                                    </span>
                                </small>
                            </div>

                            {
                                this.state.advancesOpen &&
                                <div className={"mt-2"}>
                                    {
                                        advances.map((advance, index) =>
                                            <div key={advance.id_acconto || index} className={"border rounded p-2 mb-2"}>
                                                <div className={"d-flex justify-content-between align-items-center"}>
                                                    <div>
                                                        <b>Acconto {index + 1}</b>
                                                        {
                                                            advance.data_creazione &&
                                                            <small className={"text-muted d-block"}>
                                                                {moment(advance.data_creazione).format("DD/MM/YYYY HH:mm")}
                                                            </small>
                                                        }
                                                    </div>
                                                    <span className={"font-weight-bold"}>
                                                        {formatCurrency(advance.importo || 0, "EUR", "it-IT")}
                                                    </span>
                                                </div>
                                                {this.renderAdvancePayments(advance)}
                                            </div>
                                        )
                                    }
                                </div>
                            }
                        </div>
                    }
                </div>
            </div>
        )
    }
}

ImpagatoCard.propTypes = {
    impagato: PropTypes.object,
    defaultAdvancesOpen: PropTypes.bool
}
